<template>
  <div
    v-show="visibility"
    class="-grid-cell-tree-item"
    style="width: 100%"
    :style="containerStyle"
    @mousedown="onMouseDown"
  >
    <div
      v-show="showCheckbox"
      class="sui-checkbox__check-image"
      :disabled="disabled"
      :class="checkboxClass"
      @click="onCheckboxClick"
      @mousedown.stop=""
    />
    <div
      class="sui-checkbox__label"
      :title="localValue.text"
    >
      {{ localValue.text }}
    </div>
  </div>
</template>

<script>

export default {
  name: 'CellTreeItem',
  props: {
    checkEditableFunction: {
      type: Function,
      default: null,
    },
    checkDisabledFunction: {
      type: Function,
      default: null,
    },
    checkVisibilityFunction: {
      type: Function,
      default: null,
    },
    value: {
      type: Object,
      default() {
        return {
          depth: 0,
          text: '',
          checked: false,
        };
      },
    },
  },
  data() {
    return {
      editable: true,
      disabled: false,
      visibility: true,
      localValue: this.value,
    };
  },
  computed: {
    containerStyle() {
      const padding = `${this.localValue.depth * 20}`;
      return `padding-left: ${padding}px`;
    },
    showCheckbox() {
      if (this.localValue.hasOwnProperty('checked') && this.localValue.checked !== null) {
        return true;
      }
      return false;
    },
    checkboxClass() {
      if (this.localValue.checked === true) {
        return 'sui-checkbox--check-on';
      }
      return 'sui-checkbox--check-off';
    },
  },
  beforeDestroy() {
    this.handleBeforeDestroy();
  },
  methods: {
    setEditable(rowData, columnName, dataset, grid) {
      if (this.checkEditableFunction) {
        this.editable = this.checkEditableFunction(rowData, columnName, dataset, grid);
      }
    },
    setDisabled(rowData, columnName, dataset, grid) {
      if (this.checkDisabledFunction) {
        this.disabled = this.checkDisabledFunction(rowData, columnName, dataset, grid);
      }
    },
    setVisibility(rowData, columnName, dataset, grid) {
      if (this.checkVisibilityFunction) {
        this.visibility = this.checkVisibilityFunction(rowData, columnName, dataset, grid);
      }
    },
    handleBeforeDestroy() {
      (this.$el && this.$el.parentNode)? this.$el.parentNode.removeChild(this.$el):'';
    },
    setValue(value) {
      this.localValue = value;
    },
    getValue() {
      return this.localValue;
    },
    onCheckboxClick() {
      // this.localValue.checked = !this.localValue.checked;
      if (this.disabled) {
        return;
      }
      this.$emit('checked', !this.localValue.checked);
    },
    onMouseDown() {
      // this.$emit('select-row');
    },
  },
};
</script>

<style scoped>
</style>
